"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var BasicCard = function BasicCardComponent(_ref) {
  var _ref$cardItem = _ref.cardItem,
      cardTitle = _ref$cardItem.card_title,
      cardBody = _ref$cardItem.card_body,
      dataClient = _ref.dataClient;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__basic-card"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "content-page__basic-card-title"
  }, dataClient.textToMarkdown(cardTitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__basic-card-text"
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__basic-card-text",
    content: cardBody
  })));
};

BasicCard.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  cardItem: _propTypes["default"].shape({
    card_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    card_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
  }).isRequired
};
var _default = BasicCard;
exports["default"] = _default;